import { render } from "./404.vue?vue&type=template&id=744762f6"
const script = {}
script.render = render

export default script